import cx from "classnames";
import React from "react";

import { Link } from "@/mk2/components/Link";

import styles from "./BluePill.mscss";

interface BluePillProps {
    className?: string;
    to: string;
    label: React.ReactNode;
}

export const BluePill: React.FunctionComponent<BluePillProps> = ({ className, to, label }) => (
    <Link className={cx(styles.BluePill, className)} to={to}>
        <span className={styles.BluePill__label}>{label}</span>
    </Link>
);

BluePill.displayName = "BluePill";
